import { FileExcelOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { FC, useState } from 'react';
import { useAuth } from 'src/stores/auth-context';
import { AuditLogger } from 'src/utils/audit-logger';
import {
  PurchaseOrderWithProductSupplier,
  downloadPurchaseOrderExcelFile,
} from 'src/utils/supplier-purchase-order-util';

const auditLogger = AuditLogger.getInstance();

interface AgCellDownloadPurchaseOrderExcelProps {
  purchaseOrderId: string;
  /** 물류 운영팀에서 다운로드 받는 내용에 문제가 계속해서 발생하여, 추적을 위해 추가한다. */
  purchaseOrder: PurchaseOrderWithProductSupplier;
}

const AgCellDownloadPurchaseOrderExcel: FC<AgCellDownloadPurchaseOrderExcelProps> = ({
  purchaseOrderId,
  purchaseOrder,
}) => {
  const { authUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const token = authUser ? authUser.token : null;

  const onDownloadToExcel = async () => {
    if (!purchaseOrderId) return;
    if (!token) return;
    setLoading(true);
    if (purchaseOrder) {
      auditLogger.log({
        action: 'SYNC',
        entity: 'purchaseOrder',
        entityId: purchaseOrderId,
        summary: `${purchaseOrder.productSupplier ? purchaseOrder.productSupplier.name : ''} 발주서 엑셀 다운로드 - 발주 일자: ${purchaseOrder.orderDate} / 발주 상품: ${purchaseOrder.messageRawList.length}개`,
      });
    }
    await downloadPurchaseOrderExcelFile(token, purchaseOrderId);
    setLoading(false);
  };

  if (!purchaseOrderId) return null;

  return (
    <Button
      icon={<FileExcelOutlined style={{ color: 'var(--green700)' }} />}
      onClick={onDownloadToExcel}
      loading={loading}
      disabled={!token}
    >
      엑셀Export
    </Button>
  );
};

export default AgCellDownloadPurchaseOrderExcel;
